import TermsAcceptanceHandler from '../../../javascripts/terms_acceptance_handler';

document.addEventListener('DOMContentLoaded', () => {
  const handler = new TermsAcceptanceHandler({
    submitButtonSelector: '.js-sign-in',
    singleCheckboxSelector: '#user_accepted',
    multipleCheckboxesSelector: 'input[name="user[terms_agreements_accepted][]"]'
  });

  handler.init();
});
